<i18n src="../../locales/lang.json"></i18n>

<template>
  <div>
    <div class="item-group" v-bind:class="'validation-container-'+ el.hasErrors" :key="el.Id" v-for="el in elements" v-show="el.Hidden == false">
      <!-- Text -->
      <div v-if="el.ElementType == 1" class="item item-text">
        <div v-show="el.hasErrors == true" class="row p-0 m-0">
          <div class="col-12 p-0 text-error">
            {{$t('field_is_required')}}
          </div>
        </div>
        <div class="row p-0 m-0">
          <div class="col-12 p-0">
            <div v-html="el.Text"></div>
          </div>
        </div>
      </div>
      <!-- Checkbox -->
      <div v-if="el.ElementType == 2" class="item property-border mt-3">
        <div v-show="el.hasErrors == true" class="row p-0 m-0">
          <div class="col-12 p-0 text-error">
            {{$t('field_is_required')}}
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <!--Assigned to me-->
            <div class="custom-control custom-checkbox custom-control-inline" v-if="isEnabled() == true">
              <input class="custom-control-input chk-task-success" v-bind:name="'check_' + scheduleid + '_' + el.Id" v-bind:key="'check_' + scheduleid + '_' + el.Id" v-bind:id="'check_' + scheduleid + '_' + el.Id" type="checkbox" v-bind:checked="isChecked(el)" @click="checkClick(el, 'check_' + scheduleid + '_' + el.Id, 'check_' + scheduleid + '_' + el.Id)" />
              <label class="custom-control-label chk-task-success" v-bind:for="'check_' + scheduleid + '_' + el.Id">
                {{el.Text}}
              </label>
            </div>
            <!--Not assigned to me-->
            <div class="custom-control custom-checkbox custom-control-inline disabled" v-if="isEnabled() == false">
              <input class="custom-control-input chk-task-success" disabled="disabled" v-bind:name="'check_' + scheduleid + '_' + el.Id" v-bind:key="'check_' + scheduleid + '_' + el.Id" v-bind:id="'check_' + scheduleid + '_' + el.Id " @click="alert('not assigned to me')" type="checkbox" v-bind:checked="isChecked(el)" />
              <label class="custom-control-label chk-task-success" v-bind:for="'check_' + scheduleid + '_' + el.Id">
                {{el.Text}}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div v-if="el.ElementType == 9" class="item property-border mt-3">
        <div v-show="el.hasErrors == true" class="row p-0 m-0">
          <div class="col-12 p-0 text-error">
            {{$t('field_is_required')}}
          </div>
        </div>
        <div class="col-12 px-0">
          <!--Not assigned to me-->
          <i class="icon-qrcode mr-1" style="font-size:18px;margin-top:-2px;"></i>
          <map-button class="p-0 mr-1" v-bind:zoomlevel="20" style="position:relative;" v-if="el.Settings.Property['latitude'] != null && el.Settings.Property['latitude'] != '0'" v-bind:latitude="parseFloat(el.Settings.Property['latitude'])" v-bind:longitude="parseFloat(el.Settings.Property['longitude'])" ref="mapButton"></map-button>
          <div class="custom-control custom-checkbox custom-control-inline disabled" style="display:inline-table; width:80%">
            <input class="custom-control-input chk-task-success" disabled @click.stop="showQRCodeAlert()" v-bind:name="'check_' + el.Id" v-bind:key="scheduleid + '_' + el.Id" v-bind:id="'check_'+ scheduleid + '_' + el.Id" type="checkbox" v-bind:checked="isQRChecked(el)" />
            <label class="custom-control-label chk-task-success" style="width:80%;">
              {{el.Text}}
            </label>
          </div>

        </div>
      </div>

      <!-- image/file/url inside procedure -->
      <div v-if="el.ElementType == 3" class="item">
        <div v-show="el.hasErrors == true" class="row p-0 m-0">
          <div class="col-12 p-0 text-error">
            {{$t('field_is_required')}}
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <a @click="clickItem(el)" href="#">{{el.Text}}</a>
          </div>
        </div>
      </div>
      <div v-if="el.ElementType == 0 && (el.Url != null && el.Url != '') && el.Settings.Property.IncludeInProcedure == 'true'" class="item item-smaller p-0">
        <div class="row p-0 m-0" v-show="el.Settings.Property.IncludeInProcedure == 'true'">
          <img class="item-text" v-bind:src="el.Url" width="100%" />
          <span v-if="el.Settings.Property.imagecaption">{{el.Settings.Property.imagecaption}}</span>
        </div>
      </div>

      <!-- Displays a uploaded file -->
      <div v-if="el.ElementType == 0 && (el.Url != null && el.Url != '') && el.Settings.Property.IncludeInProcedure != 'true'" class="item item-smaller">
        <div v-show="el.hasErrors == true" class="row p-0 m-0">
          <div class="col-12 p-0 text-error">
            {{$t('field_is_required')}}
          </div>
        </div>
        <div class="row" v-show="el.Settings.Property.IncludeInProcedure != 'true'">
          <div class="col-12 p-0 px-1" v-show="el.Url != null && el.Url != ''">
            <!--Identifyable file type-->
            <a target="_blank" @click="clickItem(el)" v-if="getIconImage(el) != null">
              <img v-bind:src="getIconImage(el)" width="28" height="28" style="margin-left:5px;margin-bottom:6px;" />
            </a>
            <!--default link-->
            <a target="_blank" v-if="getIconImage(el) == null" @click="clickItem(el)" style="margin-left: -5px; margin-bottom: 6px; color: inherit; cursor:pointer;"><i class="icon-link"></i></a>
            <a target="_blank" @click="clickItem(el)" style="text-decoration: underline !important; cursor: pointer;">{{el.Text}}</a>
            <button v-show="el.Overridden == true" type="button" class="btn btn-icon" style="font-size:10px; border:0; padding:5px;cursor:pointer;text-decoration:underline;" @click="deleteItem(el)"><i class="icon-cross2" style="font-size:12px;"></i></button>
          </div>
        </div>
      </div>

      <!-- not sure about this -->
      <div v-if="el.ElementType == 0 && (el.Url == null || el.Url == '') && el.Settings.Property.IncludeInProcedure != 'true'" class="item item-smaller">
        <div v-show="el.hasErrors == true" class="row p-0 m-0">
          <div class="col-12 p-0 text-error">
            {{$t('field_is_required')}}
          </div>
        </div>
        <div class="row">
          <div class="col-12 p-0">
            Image not set in procedure (Fix this text)
          </div>
        </div>
      </div>

      <!-- Uploaded documents -->
      <div v-if="el.ElementType == 5" class="item p-0 mt-3">
        <div v-show="el.hasErrors == true" class="row p-0 m-0">
          <div class="col-12 p-0 text-error">
            {{$t('field_is_required')}}
          </div>
        </div>
        <div class="row" v-show="$store.getUserPermissionLevel() >= el.UserLevel && isEnabled() == true">
          <div class="col-1 p-0 px-1" v-show="el.EnableMultiple == false && el.Elements.length > 0">
            <button @click="clickItem(el)" data-type='image' data-id='0' type='button' class='btn btn-icon' style="padding:5px; padding-top:0px;padding-bottom:0px; background-color:transparent;vertical-align:initial;color:inherit;width:initial"><i class='icon-upload4' style="top:-2px;"></i></button>
          </div>
          <div class="col-1 p-0" v-show="el.EnableMultiple == true || (el.EnableMultiple == false && el.Elements.length == 0)">
            <button data-type='image' data-id='0' type='button' class='btn btn-icon' @click="clickItem(el)" style="padding: 5px; padding-top: 0px; padding-bottom: 0px; background-color: transparent; vertical-align: initial; color: inherit; width: initial"><i class='icon-upload4' style="top:-2px;"></i></button>
          </div>
          <div class="col-11 p-0 px-2" v-show="el.Url == null || el.Url == ''" style="padding-top: 8px !important;">
            <a @click="clickItem(el)" style="text-decoration:underline !important;color:inherit;">{{el.Text}}</a>
          </div>
        </div>

        <div class="row" v-show="$store.getUserPermissionLevel() < el.UserLevel || isEnabled() == false">
          <div class="col-11 p-0 px-2" v-show="el.Url == null || el.Url == ''" style="padding-top: 8px !important;">
            {{el.Text}}
          </div>
        </div>

        <!-- Uploaded documents -->

        <div class="row" v-for="userInput in el.UserInputs">
          <div class="col-12 px-0 px-1" v-show="$store.getUserPermissionLevel() >= el.UserLevel && isEnabled() == true && userInput.IsDeleted != true" style="padding-left:12px !important;">
            <!--Identifyable file type-->
            <a target="_blank" @click="openUrl(el, userInput)" v-if="getUserInputIconImage(userInput) != null">
              <img v-bind:src="getUserInputIconImage(userInput)" width="28" height="28" style="margin-left:5px;margin-bottom:6px;" />
            </a>
            <!--default link-->
            <a target="_blank" v-if="getUserInputIconImage(userInput) == null" @click="openUrl(el, userInput)" style="margin-left: -5px; margin-bottom: 6px; color: inherit; cursor:pointer;">
              <i class="icon-link" style="padding-top:6px;margin-left: 10px; margin-bottom: 6px; width:28px;height:28px;"></i>
            </a>
            <a v-if="el.IsDeleted == true" target="_blank" @click="openUrl(el, userInput)" style="text-decoration: underline !important; cursor: pointer; text-decoration: line-through">{{userInput.Value}}</a>
            <a v-if="el.IsDeleted != true" target="_blank" @click="openUrl(el, userInput)" style="text-decoration: underline !important; cursor: pointer;">{{userInput.Value}}</a>
            <button type="button" class="btn btn-icon py-0" style="font-size:10px; border:0; padding-left:5px;cursor:pointer;text-decoration:underline;width:initial;height:initial" @click="deleteuserInputItem(el, userInput)"><i class="icon-cross2" style="font-size:12px;"></i></button>
          </div>
          <div class="col-12 px-1" v-show="$store.getUserPermissionLevel() < el.UserLevel || isEnabled() == false && userInput.IsDeleted != true">
            <!--Identifyable file type-->
            <a target="_blank" @click="openUrl(el, userInput)" v-if="getUserInputIconImage(userInput) != null">
              <img v-bind:src="getUserInputIconImage(userInput)" width="28" height="28" style="margin-left:5px;margin-bottom:6px;" />
            </a>
            <!--default link-->
            <a target="_blank" v-if="getUserInputIconImage(userInput) == null" @click="openUrl(el, userInput)" style="margin-left: -5px; margin-bottom: 6px; color: inherit; cursor:pointer;"><i class="icon-link"></i></a>
            <a target="_blank" @click="openUrl(el, userInput)" style="text-decoration: underline !important; cursor: pointer;">{{userInput.Value}}</a>
          </div>
        </div>
      </div>

      <!-- User inputs single row text -->

      <div v-if="el.ElementType == 6" class="item p-0 mt-3">
        <div v-show="el.hasErrors == true" class="row p-0 m-0">
          <div class="col-12 p-0 text-error">
            {{$t('field_is_required')}}
          </div>
        </div>
        <div class="row  mb-1" v-if="el.Text != null && el.Text != ''">
          <div class="col-12">
            {{el.Text}}
          </div>
        </div>
        <div class="row">
          <div class="col-12" v-show="$store.getUserPermissionLevel() >= el.UserLevel && isEnabled() == true">
            <input type="text" v-bind:key="scheduleid + '_' + el.Id" v-bind:id="'text_'+ scheduleid + '_' + el.Id" v-bind:name="'text_'+ scheduleid + '_' + el.Id" class="form-control" :value="getValue(el)" @input="textChanged(el,$event.target.value)" />
            <label v-if="el.IsRegxError" class="validation-invalid-label" for="username">{{$t('invalid_input')}}</label>
          </div>
          <div class="col-12" v-show="$store.getUserPermissionLevel() < el.UserLevel || isEnabled() == false">
            <div>
              {{getValue(el)}}
            </div>
          </div>
        </div>
      </div>

      <!-- User inputs multiple rows with text -->
      <div v-if="el.ElementType == 7" class="item p-0 mt-3">
        <div v-show="el.hasErrors == true" class="row p-0 m-0">
          <div class="col-12 p-0 text-error">
            {{$t('field_is_required')}}
          </div>
        </div>
        <div class="row  mb-1" v-if="el.Text != null && el.Text != ''">
          <div class="col-12">
            {{el.Text}}
          </div>
        </div>
        <div class="row">
          <div class="col-12" v-show="$store.getUserPermissionLevel() >= el.UserLevel && isEnabled() == true">
            <textarea v-bind:key="scheduleid + '_' + el.Id" v-bind:id="'text_'+ scheduleid + '_' + el.Id" v-bind:name="'text_'+ scheduleid + '_' + el.Id" class="form-control" @input="textChanged(el,$event.target.value)">{{getValue(el)}}</textarea>
          </div>
          <div class="col-12" v-show="$store.getUserPermissionLevel() < el.UserLevel || isEnabled() == false">
            <div>
              {{getValue(el)}}
            </div>
          </div>
        </div>
      </div>

      <!-- Displays a select -->
      <div v-if="el.ElementType == 8 && el.OverRidable == true" class="item py-0 px-2 mt-3">
        <div v-show="el.hasErrors == true" class="row p-0 m-0">
          <div class="col-12 p-0 text-error">
            {{$t('field_is_required')}}
          </div>
        </div>
        <div class="row">
          <div class="col-12 p-0" v-show="$store.getUserPermissionLevel() >= el.UserLevel && isEnabled() == true">
            <select v-bind:key="scheduleid + '_' + el.Id" v-bind:id="'select_' + scheduleid + '_' + el.Id" v-bind:name="'select_' + scheduleid + '_' + el.Id" class="form-control col-6" @change="doSelect(el)">
              <option v-bind:value="''" :selected="(el.UserInputs.length == 0 || (el.UserInputs[0].Value == '' && el.UserInputs[0].ConditionalValue == ''))">{{el.Text}}</option>
              <option v-for="p in getSelectItems(el)" :selected="(el.UserInputs.length > 0 && ((el.UserInputs[0].Value == p.value && el.UserInputs[0].ConditionalValue == '') || el.UserInputs[0].ConditionalValue == p.value))" v-bind:value="p.value">{{p.text}}</option>
            </select>
          </div>
          <div class="col-12 p-0" v-if="($store.getUserPermissionLevel() < el.UserLevel || isEnabled() == false) && el.UserInputs.length > 0">
            {{el.Text}}: {{el.UserInputs[0].Value}}
          </div>
          <div class="col-12 p-0" v-if="($store.getUserPermissionLevel() < el.UserLevel || isEnabled() == false) && el.UserInputs.length == 0">
            {{el.Text}}:
          </div>

        </div>
      </div>

      <div v-if="el.ElementType == 10" class="item p-0 mt-3">
        <div v-show="el.hasErrors == true" class="row p-0 m-0">
          <div class="col-12 p-0 text-error">
            {{$t('field_is_required')}}
          </div>
        </div>
        <div class="row  mb-1" v-if="el.Text != null && el.Text != ''">
          <div class="col-12">
            {{el.Text}}
          </div>
        </div>
        <div class="row">
          <div class="col-12" v-show="$store.getUserPermissionLevel() >= el.UserLevel && isEnabled() == true">
            <textarea v-bind:key="scheduleid + '_' + el.Id" v-bind:id="'text_'+ scheduleid + '_' + el.Id" v-bind:name="'text_'+ scheduleid + '_' + el.Id" class="form-control" @change="addPendingChatMessage(el,$event.target.value)" @input="textChanged(el,$event.target.value)">{{getValue(el)}}</textarea>
          </div>
        </div>

      </div>

      <div v-if="el.ElementType == 12" class="item p-0">
        <!--style="border: 3px #e5e5e8 solid"-->
        <element-view-slideshow @changed="changedPage" v-bind:el="el" v-bind:date="date" v-bind:scheduleid="scheduleid" v-bind:assigned="assigned" @deleteItem="deleteItem" @clickItem="clickItem" @openUrl="openUrl" />
      </div>

      <div v-if="el.ElementType == 17" class="item p-0 mt-3">
        <element-view-booking v-bind:el="el" v-bind:date="date" v-bind:scheduleid="scheduleid" v-bind:assigned="assigned" @deleteItem="deleteItem" @clickItem="clickItem" @openUrl="openUrl" />
      </div>

      <div v-if="el.ElementType == 16" class="item p-0 mt-3">
        <element-view-camera v-bind:el="el" v-bind:date="date" v-bind:scheduleid="scheduleid" v-bind:assigned="assigned" @deleteItem="deleteItem" @clickItem="clickItem" @openUrl="openUrl" />
      </div>

      <div v-if="el.ElementType == 18" class="item p-0 mt-3">
        <element-view-video v-bind:el="el" v-bind:date="date" v-bind:scheduleid="scheduleid" v-bind:assigned="assigned" @deleteItem="deleteItem" @clickItem="clickItem" @openUrl="openUrl" />
      </div>

      <!--title-->
      <div v-if="el.ElementType == 19" class="item item-text">
        <div v-show="el.hasErrors == true" class="row p-0 m-0">
          <div class="col-12 p-0 text-error">
            {{$t('field_is_required')}}
          </div>
        </div>
        <div class="row p-0 m-0">
          <div class="col-12 p-0">
            <h1>{{el.Text}}</h1>
          </div>
        </div>
      </div>
      <!--hidden-->
      <input v-if="el.ElementType == 20" type="hidden" :value="el.Text" />
      <!--slider-->
      <div v-if="el.ElementType == 22" class="item p-0 mt-3">
        <element-view-slider v-bind:el="el" v-bind:scheduleid="scheduleid" @deleteItem="deleteItem" @clickItem="clickItem"></element-view-slider>
      </div>
      <!--html editor-->
      <div v-if="el.ElementType == 21" class="item p-0 mt-3" v-html="getHtmlEleData(el)"></div>
      <!-- Text and textfield -->
      <nested-viewproperty v-if="el.ElementType == 6 || el.ElementType == 7 || el.ElementType == 8" v-bind:date="date" v-bind:scheduleid="scheduleid" v-bind:elements="el.Elements" v-bind:assigned="assigned" class="" @deleteItem="deleteItem" @clickItem="clickItem" @openUrl="openUrl" />

      <procedure-view-expand v-if="el.ElementType == 0 || el.ElementType == 1 || el.ElementType == 2 || el.ElementType == 4" show="true" v-bind:enabled="el.ElementType == 4" class="item" v-bind:el="el">
        <nested-viewproperty @add_pending_chat_message="addPendingChatMessage" v-bind:isshifttask="isshifttask" v-bind:assigned="assigned" @changed="changed(el)" v-bind:date="date" v-bind:scheduleid="scheduleid" v-bind:elements="el.Elements" class="item-sub" @deleteItem="deleteItem" @clickItem="clickItem" @openUrl="openUrl" />
      </procedure-view-expand>

    </div>

  </div>
</template>

<script>
  import ProcedureService from "../services/ProcedureService";
  export default {
    name: "procedure-viewproperty",
    data() {
      return {
        storeUserName: null,
      }
    }
    ,
    components: {

    },
    methods: {
      getHtmlEleData(el) {
        var data = "";
        if (el.Settings.Property.htmleditor != undefined)
          data = el.Settings.Property.htmleditor;
        return data;
      },
      onChange(el) {
        if (el.hasErrors == true)
          this.$root.$emit("revalidate")
        this.$store.markAsChanged();
      },
      async setElements(elements) {
        //alert("setElements");
        //alert(JSON.stringify(elements))
        this.elements = elements;
        Vue.set(this, "elements", elements);
        this.$forceUpdate();
        //this.elements = elements;
      },
      isEnabled() {
        return (this.assigned == this.storeUserName || this.isshifttask == true || this.$store.getUserPermissionLevel() > 2);
      },
      showQRCodeAlert() {
        alert("this is a QR code, you need to scan to mark as done");
      },
      getIconImage(el) {
        return ProcedureService.getIconImage(el);
      },
      getUserInputIconImage(userInput) {
        if (userInput.Settings && userInput.Settings.Property && userInput.Settings.Property.mimetype && userInput.Settings.Property.mimetype != null) {
          return this.getIconFromMimetype(userInput.Settings.Property.mimetype);
        }
        else if (userInput.Url != null)
          return this.getIconFromMimetype(userInput.Url);
        return null;
      },
      getIconFromMimetype(mimetype) {
        return ProcedureService.getIconFromMimetype(mimetype);
      },
      getValue(el) {

        var returnVal = "";
        if (el.UserInputs != null && typeof (el.UserInputs != 'undefined') && el.UserInputs.length > 0) {
          if (el.UserInputs[0].ConditionalValue && el.UserInputs[0].ConditionalValue != '') {
            returnVal = el.UserInputs[0].ConditionalValue;
          }
          else {
            returnVal = el.UserInputs[0].Value;
          }

        }
        return returnVal;
      },
      textChanged(el, val) {
        var v = JSON.parse(JSON.stringify(val));

        if (el.ValidationRegx && v) {
          var re = new RegExp(el.ValidationRegx);
          if (re.test(v)) {
            el.IsRegxError = false;
          } else {
            el.IsRegxError = true;
          }
        } else {
          el.IsRegxError = false;
        }

        var userInput = {
          ElementType: el.ElementType,
          Value: v,
          IsChanged: true
        };

        if (el.UserInputs.length > 0) {
          el.UserInputs[0].IsChanged = true;
          el.UserInputs[0].Value = userInput.Value;
        }
        else {

          userInput.ParentId = el.Id;
          el.UserInputs.push(userInput);
        }
        Vue.set(el, "UserInputs", el.UserInputs)

        this.onChange(el);
        //this.$emit("changed")
      },
      addPendingChatMessage(el, val) {
        this.$emit("add_pending_chat_message", val, el);
      },
      reload() {
        //this.$forceUpdate();
      },
      deleteItem(el) {
        this.$emit('deleteItem', el);
        this.$emit("changed")
      },
      deleteuserInputItem(el, userInput) {
        userInput.IsDeleted = true;
        //const index = el.UserInputs.indexOf(userInput);
        //if (index > -1) {
        //  el.UserInputs.splice(index, 1);
        //}
        Vue.set(el, "UserInputs", el.UserInputs);
        this.$emit("changed");
      },
      openUrl(el, userInput) {
        this.$emit('openUrl', userInput.Url, userInput.Value);
      },
      clickItem(el) {
        this.$emit('clickItem', el);
      },
      isChecked(el) {
        var val = this.getValue(el);
        if (val == "DONE")
          return true;
        return false;
      },
      isQRChecked(el) {

        if (el.UserInputs.length > 0)
          if (el.UserInputs[el.UserInputs.length - 1].Value == "DONE")
            return true;
        return false;
      },
      checkClick(el, id, elId) {
        var val = $("#" + elId).prop("checked");
        var tmpStatus = 2;
        var userInput = {
          ElementType: 2,
          IsChanged: true
        };

        if (val) {
          userInput.Value = "DONE";
          tmpStatus = 2;
        }
        else {
          userInput.Value = "NOTDONE";
          tmpStatus = 1;
        }

        if (el.UserInputs.length > 0) {
          el.UserInputs[0].IsChanged = true
          el.UserInputs[0].Value = userInput.Value;

        }
        else {
          userInput.ParentId = el.Id;
          el.UserInputs.push(userInput);
        }

        Vue.set(el, "UserInputs", el.UserInputs)
        this.onChange(el);
      },
      getChecked(el) {
        return el.IsTaskDone;
      },
      changed() {
        this.$emit("changed")
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      getSelectItems(el) {
        var currentOptions = [];
        if (el.Settings != null && el.Settings.Property && el.Settings.Property["options"]) {
          //if (el.Settings && el.Settings.Property) {
          currentOptions = JSON.parse(el.Settings.Property["options"]);
        }
        return currentOptions;
      },
      doSelect(el) {
        var userInput = {
          ElementType: el.ElementType,
          Value: $('#select_' + this.scheduleid + '_' + el.Id).val(),
          IsChanged: true
        };

        if (el.UserInputs.length > 0) {
          el.UserInputs[0].IsChanged = true
          el.UserInputs[0].Value = userInput.Value;
        }
        else {
          userInput.ParentId = el.Id;
          el.UserInputs.push(userInput);
        }

        Vue.set(el, "UserInputs", el.UserInputs)
        this.onChange(el);
      },
      /*
      changedPage(elements, index) {
        //alert("updating")
        //alert(JSON.stringify(this.elements))
        //this.elements[0].elements = elements;
        this.elements = elements;
        Vue.set(this, "elements", this.elements);
        //this.$forceUpdate()
      },
      */
      changedPage() {
        //alert("changedPage");
        this.$emit("changed")
      }

    },
    computed: {
      isTmpEnabled: {
        get() {
          return this.isEnabled();
        },
      },
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          this.$store.commit('saveprocedure', value)
        }
      }
    },
    props: {
      elements: {
        required: false,
        type: Array,
        default: []
      },
      date: {
        required: false,
        tyrrpe: String,
        default: null
      },
      scheduleid: {
        required: false,
        type: String,
        default: null
      },
      assigned: {
        required: false,
        type: String,
        default: null
      },
      isshifttask: {
        required: false,
        type: Boolean,
        default: false
      },
      visible: {
        required: false,
        type: Boolean,
        default: true
      },

    },
    mounted() {
      this.storeUserName = this.$store.getUsername();
      this.$root.$on('procedure_refresh', this.handleRefresh);
    },
    watch: {

    },
  };
</script>


<style scoped>

  .text-error {
    color: #FE7300
  }

  .chk-task-success:checked ~ .custom-control-label::before {
    background-color: rgb(180, 228, 94) !important;
  }

  .property-border {
    margin-top: 3px;
    border: 1px solid #DDDEDF;
  }

  .validation-container-true .property-border {
    border: 1px solid #FE7300;
  }

  .custom-control-inline {
    display: block;
  }

  label {
    display: block;
    width: 100%;
  }

  .item-container {
    margin: 0;
  }

  .item {
    padding: 1rem;
    /*background-color: #fefefe;*/
  }

  .item-text {
    padding-top: 5px;
    padding-left: 0px;
    padding-right: 0px;
  }

  .item-smaller {
    padding-top: 5px;
    padding-bottom: 5px;
    /*background-color: #fefefe;*/
  }

  .item-sub {
    margin: 0 0 0 1rem;
  }

  .custom-checkbox .custom-control-label::before {
    margin-top: 0px;
  }

  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
    margin-top: 0px;
  }

  div {
    list-style: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/nested-viewproperty.vue